import { Outlet } from 'react-router-dom';
import CookieConsentBanner from './CookieConsentBanner';
import CookieSettingsModal from './CookieSettingsModal';

export default function RootLayout() {
  return (
    <>
      <Outlet />
      <CookieConsentBanner />
      <CookieSettingsModal />
    </>
  );
}
